var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-card',{staticClass:"mar-b-15"},[_c('avue-form',{ref:"form",attrs:{"option":_vm.option},on:{"submit":_vm.handleSearchForm},model:{value:(_vm.obj),callback:function ($$v) {_vm.obj=$$v},expression:"obj"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }